import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class ApiService {

	constructor(private http: HttpClient) { }

	//authentication apis

	registerUser(user): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/registration', user);
	}

	loginUser(user): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/login', user);
	}

	forgotPassword(email): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/forgotPassword', email);
	}

	validateToken(token): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/validateToken', token);
	}

	resetPassword(obj): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/resetPassword', obj);
	}

	// saved locations fetch
	getSavedLocations(obj): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/getSavedLocations/' + obj);
	}

	saveLocation(obj): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/saveLocation', obj);
	}

	deleteLocation(data): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/deleteLocation', data);
	}

	editLocation(obj): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/editLocation', obj);
	}

	//trips
	viewTrips(obj): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/viewTrips', { params: obj });
	}

	deleteTrip(data): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/deleteTrip', data);
	}

	joinTrips(data): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/jointrip', data);
	}

	splitTrips(data): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/splitTrip', data);
	}

	// user rate
	getUserRates(obj): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/getUserRates/' + obj);
	}

	//basic info
	getUserInfo(): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/getUserInfoUpdate');
	}

	updateUserInfo(obj): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/userInfoUpdate', obj);
	}

	//email
	updateUserEmail(obj): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/emailUpdate', obj);
	}

	//timezone
	getTimeZoneJSON(): Observable<any> {
		return this.http.get('../../../../assets/json/timezoneUTC.json');
	}

	//password
	updateUserPassword(obj): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/changePassword', obj);
	}

	//employee list
	getEmployeeList(): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/getUserList');
	}

	//google directions
	getGoogleDirection(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/googleDirection', param);
	}

	//google places
	getGooglePlaces(param): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/googleLocation', { params: param });
	}

	//trip
	addTrip(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/manual', param);
	}

	//currency
	getCurrencyJSON(): Observable<any> {
		return this.http.get('../../../../assets/json/currencycode.json');
	}

	//country
	getCountryJSON(): Observable<any> {
		return this.http.get('../../../../assets/json/country.json');
	}

	//rate update
	updateRates(param): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/manageRates', param);
	}

	//create report
	createReport(data): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/createIndividualReport', data);
	}

	//device list
	getDeviceList(): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/manageDevices');
	}

	//manage user
	getUserDeviceList(): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/manageUsers');
	}

	//add users
	saveUserInfo(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/addManagedUser', param);
	}

	//remove users
	removeUser(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/removeUser', param);
	}

	//remove device
	removeDeviceFromUser(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/unAssignDevices', param);
	}

	//assign device
	assignDeviceToUser(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/assignDevices', param);
	}

	//report list
	getReportList(param): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/getreport', { params: param });
	}

	//delete reports
	deleteReports(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/deleteReport', param);
	}

	//report html
	getReportHtml(param): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/getReportHtml', { params: param });
	}

	//get pdf or csv
	generatePdfCsv(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/createPdf', param);
	}

	//create summary report
	createSummaryReport(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/createSummaryReport', param);
	}

	//manage invite
	manageInvite(token): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/managedUserResponse', token);
	}

	//admin's user list
	getAdminUserList(param): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/searchAdminUsers', { params: param });
	}

	//admin device list
	getAdminDeviceList(): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/getAvailableDevices');
	}

	//assign device by admin
	assignAdminDeviceToUser(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/assignDevicesToUser', param);
	}
	//remove device by admin
	removeDevice(param): Observable<any>{
		return this.http.post(environment.API_ENDPOINT + '/removeDevice', param);
	}

	// edit trip
	editTrip(param): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/editTrip', param);
	}

	//Monthly mileage data
	getMonthlyMileageData(param): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/monthlyMileage', { params: param });
	}

	//Trip type data
	getTripTypeData(param): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/tripType', { params: param });
	}

	//add device
	addDevice(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/deviceRegistration', param);
	}

	// edit user
	editUser(param): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/editManagedUsers', param);
	}

	//Trip type data
	getDetailsFromLatLng(param): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/getDetailsFromPlaceId', param);
	}

	// edit user
	editNickName(param): Observable<any> {
		return this.http.put(environment.API_ENDPOINT + '/editNickname', param);
	}

	//Get Users Device Location Details
	getDeviceLocations(): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/userDeviceList');
	}

	//Get token for thingspace api
	getThingspaceToken(): Observable<any> {
		return this.http.get(environment.API_ENDPOINT + '/thingspaceAuthToken');
	}

	//sens sms using thingspace api
	sendSms(param, headers): Observable<any> {
		return this.http.post(environment.API_ENDPOINT + '/sendSms', param, { headers });
	}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/services/api.service.ts